import React from "react";

// CSS Styling
import "../../styles/admin.css";
import "../../styles/isaAcademy.css";

// Images and Icons
import NotepadPencil from "../../images/icons/NotepadPencil.png";

// React lottie
import Lottie from "react-lotties";
import PaperPlane from "../../lotties/paperplane.json";

// Moment.js
import moment from "moment";

// Sweet Alert v2
import Swal from "sweetalert2";

import * as XLSX from "xlsx";

// helpers
import { formatIndoPhoneNumber } from "../../helpers/formatPhoneNumber";

const DownloaderTable = (props) => {
  const { navigate, isLoading, downloaders, setLoading } = props;

  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: PaperPlane,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const handleExportDownloaders = async (downloaders) => {
    try {
      setLoading(true);
      let finalDownloadersArr = downloaders;
      finalDownloadersArr = finalDownloadersArr.map((downloader, index) => {
        return {
          No: index + 1,
          File: downloader.file_name,
          Name: downloader.name,
          "Email Address": downloader.email,
          Phone: formatIndoPhoneNumber(downloader.phone_number),
          "Company name": downloader.company_name,
          "Downloaded at": `${moment(downloader.downloadedAt).format("DD/MM/YYYY")} ${moment(downloader.downloadedAt).format("HH:mm")}`,
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(finalDownloadersArr);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(
        workbook,
        `ISA-file-downloaders-data-${moment().format("DD-MM-YYYY-HH-MM")}.xlsx`,
      );
      setLoading(false);
      Swal.fire({
        customClass: {
          confirmButton: "publishButton",
          title: "publishTitle",
          popup: "publishPopup",
        },
        showCloseButton: true,
        confirmButtonColor: "#1F81DC",
        title: "Success!",
        text: "You have successfully exported downloaders",
        confirmButtonText: "Okay, got it!",
      });
    } catch (err) {
      console.log(err?.message || "Internal Server Error.");
    }
  };

  return (
    <div>
      <div className="adminPostList">
        <div className="adminPostListTitleContainer">
          <div className="adminPostListTitle">
            <p>Downloaders</p>
          </div>
          <div className="adminPostListFunction">
            {/* filter button goes here */}
            <div className="adminPostListEachFunction addPostButton">
              <button onClick={() => handleExportDownloaders(downloaders)}>
                Export
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="adminPostTable">
        <div className="adminPostTableContainer">
          <table>
            <thead>
              <tr>
                <th className="thWorkshopTitle">File</th>
                <th>Name</th>
                <th>Email</th>
                <th>Company</th>
                <th className="thLastModified">Downloaded at</th>
              </tr>
            </thead>
            <tbody>
              {!isLoading && downloaders.length > 0 ? (
                downloaders.map((downloader) => (
                  <tr key={downloader.id} className="adminTableRow">
                    <td>{downloader.file_name}</td>
                    <td>{downloader.name}</td>
                    <td>{downloader.email}</td>
                    <td>{downloader.company_name}</td>
                    <td className="tdLastModified">
                      <div style={{ marginRight: "1em" }}>
                        {`${moment(downloader.downloadedAt).format("DD/MM/YYYY")}`}
                      </div>
                      <div>
                        {moment(downloader.downloadedAt).format("HH:mm")}
                      </div>
                    </td>
                  </tr>
                ))
              ) : isLoading ? (
                <div
                  style={{
                    width: "75%",
                    position: "absolute",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "center",
                    marginTop: "5em",
                  }}
                >
                  <Lottie options={lottieOptions} height={200} width={400} />
                  <h4
                    style={{
                      color: "#0D4C86",
                    }}
                  >
                    LOADING
                  </h4>
                  <p
                    style={{
                      color: "#0D4C86",
                    }}
                  >
                    Processing your request, please wait...
                  </p>
                </div>
              ) : (
                <div
                  style={{
                    width: "75%",
                    position: "absolute",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "center",
                    marginTop: "5em",
                  }}
                >
                  <div>
                    <img
                      src={NotepadPencil}
                      alt="Data not found icon"
                      width={350}
                    />
                  </div>
                  <h4
                    style={{
                      color: "#0D4C86",
                    }}
                  >
                    There is no downloader yet
                  </h4>
                </div>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DownloaderTable;
